<template>
    <div id="user_log_entry_view">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name" >
                    <div class="page-title"> User Log Entry View</div>
                    <router-link
                        class="btn btn-secondary pull-right"
                        v-bind:to="{name: 'UserLogEntryNew'}" 
                    > <i class="fp-back"> </i> Back</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content user-logentry-view">
                        <section class="internal-container border-top-table-fl data-table">
                            <vue-good-table
                                ref="listUserLogEntry"
                                mode="remote"
                                title="User Log Entry"
                                :totalRows="totalRecords"
                                :columns="timeColumns"
                                :rows="rows" >
                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <template v-if="props.column.field == 'action'">
                                            <template v-if="canChangeStatus">
                                                <!-- Check if shift is end and updated duration is added then show approve button-->
                                                <template v-if="props.row.duration != '-' && props.row.updated_duration != '-' && (props.row.wo_log_status == 'disapprove' || props.row.wo_log_status == 'done')">
                                                    <a href="javascript:void(0);" v-on:click.prevent="changeStatus(props.row)">
                                                        <span style="font-size:16px;" title="Approve Log" class="fp-ok-icon bold color-green"></span>
                                                    </a>
                                                </template>
                                            </template>
                                        </template>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>
                            </vue-good-table>
                        </section>    
                    </div>    
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>        
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
export default {
    name: "UserLogEntryView",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "User Log Entry View | " +process.env.COPYRIGHT_NAME
    },
    
    mixins: [commonMixins, contractMixins],
    data: () => ({
        loading:false,
        rows: [],
        totalRecords: 0,
        permissions:[],
        cantAccessPage:"",
        logId:0,
        timeColumns:[
          {
            label: 'Work',
            field: 'work',
            filterable: true,
            fpFieldType:"text",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Requested Name", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable: false,
          },
          {
            label: 'Start Time',
            field: 'start',
            filterable: true,
            fpFieldType:"text",
            sortable: false,
            //hidden:false,
            // filterOptions: {
            //     enabled: false, // enable filter for this column
            //     placeholder: "Requested Name", // placeholder for filter input
            //     filterValue: '', // initial populated value for this filter
            //     trigger: "enter" //only trigger on enter not on keyup
            // }
          },
          {
            label: 'End Time',
            field: 'end',
            filterable: true,
            fpFieldType:"text",
            sortable: false,
            // hidden:false,
            // filterOptions: {
            //     enabled: false, // enable filter for this column
            //     placeholder: "Requested Name", // placeholder for filter input
            //     filterValue: '', // initial populated value for this filter
            //     trigger: "enter" //only trigger on enter not on keyup
            // }
          },
          {
            label: 'Duration',
            field: 'duration',
            filterable: true,
            fpFieldType:"text",
            sortable: false,
            // hidden:false,
            // filterOptions: {
            //     enabled: false, // enable filter for this column
            //     placeholder: "Requested Name", // placeholder for filter input
            //     filterValue: '', // initial populated value for this filter
            //     trigger: "enter" //only trigger on enter not on keyup
            // }
          },
          {
            label: 'Updated Duration',
            field: 'updated_duration',
            filterable: true,
            fpFieldType:"text",
            sortable: false,
            // hidden:false,
            // filterOptions: {
            //     enabled: false, // enable filter for this column
            //     placeholder: "Requested Name", // placeholder for filter input
            //     filterValue: '', // initial populated value for this filter
            //     trigger: "enter" //only trigger on enter not on keyup
            // }
          },
          {
            label: 'Actions',
            field: 'action',
            sortable: false,
          },
        ],
        canChangeStatus:false
    }),
    watch:{

        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                
                if(permissions.name == 'user_log_entry_view') {
                    self.cantAccessPage = true;
                } 
                if(permissions.name == 'user_log_entry_status_change') {
                    self.canChangeStatus = true;
                }
            });            
        },
    },
    created: function() {
        var self = this;
    },
    mounted: function () {

        this.getPermissions();
        var self = this;
        self.logId = self.$route.params.id;
        self.loadUserLog();
    },
    methods: {
        loadUserLog() {
            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/user-workdata/view",
                type: "POST",
                headers: this.ajxHeaders,
                data:{id:self.logId},
                dataType: "json",
                success: function (data) {

                    self.loading = false;

                    if (data.status == "success") {
                        
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-detail-view');
                }
            });
        },
        changeStatus(rowData) {
            var self = this;
            console.log(rowData);
            if (confirm('Are you sure that you want to approve User Log Time? ')) {
                if (rowData != undefined) {

                    self.loading = true;
                    var fields = {};

                    if (rowData.wo_labor_id != null) {
                        fields = {
                            log_id:rowData.log_id,
                            time_log_id:rowData.id,
                            updated_duration:rowData.updated_duration,
                            wo_labor_id:rowData.wo_labor_id,
                            labor_code_id:"-"
                        };
                    }else{
                        fields = {
                            log_id:rowData.log_id,
                            time_log_id:rowData.id,
                            updated_duration:rowData.updated_duration,
                            wo_labor_id:"-",
                            labor_code_id:rowData.labor_code_id
                        };
                    }

                    console.log(fields);

                    $.ajax({
                        url: process.env.ROOT_API + "/user-timelog/approve",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            
                            if (data.status == "success") {
                                self.$swal('','User Time Log Updated Successfully.','success');
                                self.loadUserLog();
                            }
                        },
                        error: function (jqXHR, exception) {
                            
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'user-log-change-status');
                        }
                    });
                }
            }
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/WorkEntry/UserLogEntryView.vue